import { RootState } from "../store";
import { createSelector, createSlice } from "@reduxjs/toolkit";

interface IProfileState {
  profileSideMenuOpen: boolean;
  linkCopiedOpen: boolean;
  QRCodeCopiedOpen: boolean;
  affiliatesLinkSidebarOpen: boolean;
  affiliatesFilterSidebarOpen: boolean;
}

const initialState: IProfileState = {
  profileSideMenuOpen: false,
  linkCopiedOpen: false,
  QRCodeCopiedOpen: false,
  affiliatesLinkSidebarOpen: false,
  affiliatesFilterSidebarOpen: false,
};

export const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    setProfileSideMenuOpen(state) {
      state.profileSideMenuOpen = true;
    },
    setProfileSideMenuClose(state) {
      state.profileSideMenuOpen = false;
    },
    setLinkCopiedOpen(state) {
      state.linkCopiedOpen = true;
    },
    setLinkCopiedClose(state) {
      state.linkCopiedOpen = false;
    },
    setQRCodeCopiedOpen(state) {
      state.QRCodeCopiedOpen = true;
    },
    setQRCodeCopiedClose(state) {
      state.QRCodeCopiedOpen = false;
    },
    setAffiliatesLinkSidebarOpen(state) {
      state.affiliatesLinkSidebarOpen = true;
    },
    setAffiliatesLinkSidebarClose(state) {
      state.affiliatesLinkSidebarOpen = false;
    },
    setAffiliatesFilterSidebarOpen(state) {
      state.affiliatesFilterSidebarOpen = true;
    },
    setAffiliatesFilterSidebarClose(state) {
      state.affiliatesFilterSidebarOpen = false;
    },
  },
});

const profileState = (state: RootState) => state.profile;

export const profileSideMenuOpenSelector = createSelector(
  profileState,
  (s) => s.profileSideMenuOpen
);

export const linkCopiedOpenSelector = createSelector(
  profileState,
  (s) => s.linkCopiedOpen
);

export const QRCodeCopiedOpenSelector = createSelector(
  profileState,
  (s) => s.QRCodeCopiedOpen
);

export const affiliatesLinkSidebarSelector = createSelector(
  profileState,
  (s) => s.affiliatesLinkSidebarOpen
);

export const affiliatesFilterSidebarSelector = createSelector(
  profileState,
  (s) => s.affiliatesFilterSidebarOpen
);

export const {
  setProfileSideMenuOpen,
  setProfileSideMenuClose,
  setLinkCopiedOpen,
  setLinkCopiedClose,
  setQRCodeCopiedOpen,
  setQRCodeCopiedClose,
  setAffiliatesLinkSidebarOpen,
  setAffiliatesLinkSidebarClose,
  setAffiliatesFilterSidebarOpen,
  setAffiliatesFilterSidebarClose,
} = profileSlice.actions;

export default profileSlice.reducer;
